import { render } from "./Bid.vue?vue&type=template&id=2a84d425&scoped=true&ts=true"
import script from "./Bid.vue?vue&type=script&lang=ts"
export * from "./Bid.vue?vue&type=script&lang=ts"

import "./Bid.vue?vue&type=style&index=0&id=2a84d425&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a84d425"]])

export default __exports__